import {
    GET_REASSIGN_OVERRIDE_USERS,
    GET_REASSIGN_OVERRIDE_USERS_SUCCESS,
    GET_REASSIGN_OVERRIDE_USERS_FAILURE,
    RESET_REASSIGN_OVERRIDE_USERS,
} from '../actions';

const getUsersFromResponse = (data) => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.reassignUsers)) return data.reassignUsers;
    if (Array.isArray(data?.reassignUsers?.user)) return data.reassignUsers.user;
    if (Array.isArray(data?.reassignUserList)) return data.reassignUserList;
    if (Array.isArray(data?.usersList)) return data.usersList;
    if (Array.isArray(data?.users)) return data.users;
    if (Array.isArray(data?.users?.user)) return data.users.user;
    if (Array.isArray(data?.userList)) return data.userList;
    return [];
};

const initialState = {
    loading: false,
    reassignUsers: [],
    statusCode: '',
    statusMessage: '',
};

const reassignOverrideUsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REASSIGN_OVERRIDE_USERS:
            return {
                ...state,
                loading: true,
                statusCode: '',
                statusMessage: '',
            };
        case GET_REASSIGN_OVERRIDE_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                reassignUsers: getUsersFromResponse(action.data),
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case GET_REASSIGN_OVERRIDE_USERS_FAILURE:
            return {
                ...state,
                loading: false,
                reassignUsers: [],
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case RESET_REASSIGN_OVERRIDE_USERS:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default reassignOverrideUsersReducer;